import { IconPropsType } from "./type";

export const Comment = ({
  size = 24,
  color = "currentColor",
}: IconPropsType) => (
  <svg width={size} height={size} viewBox="0 0 14 13" fill="none">
    <path
      d="M1.82299 9.11648C1.90877 9.33284 1.92786 9.56992 1.87783 9.79723L1.25658 11.7164C1.23656 11.8137 1.24173 11.9145 1.27161 12.0093C1.30149 12.1041 1.35508 12.1896 1.4273 12.2579C1.49952 12.3261 1.58797 12.3748 1.68428 12.3993C1.78058 12.4237 1.88154 12.4232 1.97758 12.3977L3.96849 11.8156C4.18299 11.773 4.40513 11.7916 4.60958 11.8692C5.85522 12.4509 7.26629 12.574 8.59383 12.2167C9.92137 11.8594 11.0801 11.0448 11.8655 9.91644C12.6509 8.78811 13.0126 7.41863 12.8867 6.04963C12.7608 4.68063 12.1554 3.40008 11.1774 2.43392C10.1993 1.46776 8.91149 0.878082 7.54105 0.768916C6.17061 0.65975 4.80566 1.03812 3.687 1.83726C2.56835 2.6364 1.76789 3.80496 1.42685 5.13676C1.08581 6.46857 1.22611 7.87803 1.82299 9.11648Z"
      stroke={color}
      strokeWidth="1.16667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
